import { router, useLocalSearchParams } from 'expo-router';
import { Platform, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import DistancesForm from '@/components/forms/DistancesForm';
import Text from '@/components/Text';
import { SIGN_IN_BUTTON_BOTTOM } from '@/constants/layout';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';

const DistancesScreen = () => {
  const colors = useColor();
  const { onBoardingId, buyingShow } = useLocalSearchParams<{ onBoardingId: string; buyingShow: string }>();

  //Locales
  const titleText = i18n.t('sign_in.individual.distances.title');

  const successFn = () => {
    router.replace({ pathname: '/login/individual/interests', params: { onBoardingId: onBoardingId, buyingShow } });
  };

  return (
    <SafeAreaView style={styles.contentWrapper}>
      <View style={styles.titleContainer}>
        <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
          {titleText}
        </Text>
      </View>
      <View style={styles.formContainer}>
        <DistancesForm
          defaultValues={{
            searchRange: undefined,
            location: undefined,
            address: undefined
          }}
          onBoardingId={onBoardingId}
          onSuccessFn={successFn}
        />
      </View>
    </SafeAreaView>
  );
};

export default DistancesScreen;

const styles = StyleSheet.create({
  contentWrapper: {
    flex: 1
  },

  titleText: {
    fontSize: 22,
    marginBottom: 25,
    textAlign: 'center',
    marginTop: Platform.select({ ios: 18, android: 28 })
  },

  titleContainer: {
    marginBottom: 20
  },

  formContainer: {
    flex: 1,
    marginBottom: SIGN_IN_BUTTON_BOTTOM
  }
});
